import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/invoice.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_idc.png";
import { Link } from "react-router-dom";

const resultsData = [
  {
    metric: "Invoice processing time",
    before: "Slow manual entry",
    after: "80% faster",
  },
  {
    metric: "Invoices handled",
    before: "Limited manual capacity",
    after: "300% increase",
  },
  {
    metric: "Data entry errors",
    before: "Frequent",
    after: "Reduced significantly",
  },
  {
    metric: "Approval turnaround",
    before: "Delayed",
    after: "Much faster",
  },
  {
    metric: "Accounts payable workload",
    before: "Manual follow-up",
    after: "Automated workflow",
  },
  {
    metric: "Hours saved monthly",
    before: "0",
    after: "60+ hours",
  },
];

const featureCards = [
  {
    icon: "bi bi-cpu-fill",
    title: "AI Data Extraction",
    desc: "Automatically extracts supplier name, invoice number, date, amount, tax, and line items without manual data entry.",
  },
  {
    icon: "bi bi-cash-stack",
    title: "Accounts Payable",
    desc: "Helps manage vendor invoices, payment tracking, approval status, and payable records in a more structured workflow.",
  },
  {
    icon: "bi bi-receipt-cutoff",
    title: "Accounts Receivable",
    desc: "Supports customer invoice tracking, receivable updates, payment follow-ups, and outstanding amount visibility.",
  },
  {
    icon: "bi bi-bar-chart-fill",
    title: "Financial Reporting & Reviews",
    desc: "Generates useful finance summaries and reports to support management review, tracking, and decision-making.",
  },
  {
    icon: "bi bi-arrow-left-right",
    title: "Reconciliation",
    desc: "Helps compare invoices, payments, and records to identify mismatches and improve financial accuracy.",
  },
  {
    icon: "bi bi-calculator-fill",
    title: "Built for Accounting Workflows",
    desc: "Suitable for finance teams, accounting operations, invoice processing, payment tracking, and business reporting.",
  },
];

const faqs = [
  {
    q: "How is this different from normal invoice entry software?",
    a: "Traditional tools still depend heavily on manual uploads and data entry. Our AI reads invoices from WhatsApp, images, and PDFs, extracts key fields automatically, and supports real business workflows.",
  },
  {
    q: "Can it integrate with our accounting system?",
    a: "Yes. Our AI solution can connect with your existing accounting or ERP systems through API integration. It can also fit into your current approval and finance workflow.",
  },
  {
    q: "What invoice formats does it support?",
    a: "It supports invoice images, scanned files, PDFs, and WhatsApp-uploaded documents. The AI can read both structured and semi-structured invoice formats.",
  },
  {
    q: "Can it extract line items and tax details?",
    a: "Yes. The system can capture invoice number, vendor details, dates, totals, tax values, and line-item information depending on document quality and format.",
  },
  {
    q: "Can it reduce manual accounting effort?",
    a: "Yes. It automates invoice capture, data extraction, validation, and follow-up, helping finance teams save time and reduce manual errors.",
  },
  {
    q: "Who is this solution suitable for?",
    a: "It is ideal for businesses handling large volumes of invoices, finance teams managing accounts payable, and companies looking to automate invoice processing through WhatsApp.",
  },
];

const Wa_Invoice = () => {
  pageTitle("WhatsApp Accounting");

  const [openIndex, setOpenIndex] = useState(0);
  const handleWhatsAppClick = () => {
    const phoneNumber = "6581685898"; // WhatsApp number (no '+' or spaces)
    const message = "Hello! I would like to know more about your services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered <br /> WhatsApp Accounting
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>

            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for real-time accounting workflows
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Most accounting workflows slow down when finance documents are
                  handled manually. Teams deal with invoices, receipts, PDFs,
                  and images in many different formats. Manual entry,
                  verification, and follow-up often lead to delays and human
                  errors. Our WhatsApp AI is designed to support these
                  real-world accounting workflows. It helps process financial
                  documents faster with less back-and-forth.
                </p>
                <p className="siw-rpa-desc">
                  It works based on your actual finance process and approval
                  flow. The system can extract supplier details, invoice
                  numbers, dates, totals, tax data, and line items. It can
                  process WhatsApp-shared documents, scanned files, and PDF
                  invoices smoothly. This creates a faster and more accurate
                  experience for your accounting team. It also reduces manual
                  effort and improves finance operations efficiency.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/Wq-Pk2-oudg?si=1h87wXi41A2whVkY"
                  title="WhatsApp Accounting Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>
          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />
          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className="mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Wa_Invoice;
